import Session from '../auth/Session';

export class SessionExpiredError extends Error {
    constructor() {
        super('Session expired');
        this.name = 'SessionExpiredError';
    }
}

// Wraps fetch with a Bearer token and centralized 401 handling.
// On a 401, clears the stale session and does a full-page redirect to
// /login with a message, then throws so the caller's try/catch stops
export async function authFetch(url, options = {}) {
    const token = Session.getToken();
    const isFormData = typeof FormData !== 'undefined' && options.body instanceof FormData;

    const response = await fetch(url, {
        ...options,
        headers: {
            ...(!isFormData && options.body ? { 'Content-Type': 'application/json' } : {}),
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            ...options.headers,
        },
    });

    if (response.status === 401) {
        Session.removeUserSession();
        sessionStorage.setItem(
            'sessionExpiredMessage',
            'Your session has expired. Please log in again to continue.'
        );
        window.location.href = '/login';
        throw new SessionExpiredError();
    }

    return response;
}